export const viewHistoryLoading =  ({store})  => store.viewHistoryReducer.loading;

export const viewHistoryError =  ({store})  => store.viewHistoryReducer.error;

export const viewHistoryData =  ({store})  => store.viewHistoryReducer.data;